// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile_page {
	padding: 30px
}

.profile_container {
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 30px;
	row-gap: 30px
}

.profile_card {
	border-radius: 20px;
	background: #fff;
	padding: 30px;
	min-height: 250px;
	min-width: 400px;
	position: relative;


	display: flex;
	flex-direction: column;
	justify-content: space-between
}

.full {
	width: 100%;
	margin-top: 30px;
	margin-bottom: 30px;
}

.profile_card-image {
	position: absolute;
	top: 0;
	right: 0;
	max-Width: 150px
}

.profile_employee-container {
	display: flex;
	flex-wrap: wrap;
	margin-top: 20px;
}

.profile_employee-container p {
	width: -moz-fit-content;
	width: fit-content;
	color: rgb(168, 168, 168);
	/* padding: 0 0 12px 0; */
padding: 1em;
	font-weight: 600;
}


.profile_company-address {
	color: rgb(168, 168, 168);
	font-weight: 600;
	margin-right: auto;
	display: flex;
	flex-direction: column;
	font-size: 1em;
}

.profile_company-address p {
	color: #000 !important;
	font-size: 1.1em;
}

.profile_location-text {
	width: 30%;
	color: rgb(168, 168, 168);
	margin-Top: 20px;
	min-width: 200px;
}

.profile_location-missingCompanies {
	font-size: 0.9rem !important
}

@media (max-width: 1400px) {
	h1 {
		font-size: 1.5em
	}

	.profile_card h1:nth-child(2) {
		font-size: 48px;
	}

	.profile_location-text {
		width: 45%
	}
}

@media (max-width: 900px) {
	.profile_container {
		grid-template-columns: 1fr;
	}

	.profile_location-text {
		width: 60%
	}

	.profile_employee-container p {
		/* width: 33%; */
width: -moz-fit-content;
width: fit-content;
padding: .5em
	}
}

@media (max-width: 600px) {
	.profile_employee-container p {
		/* width: 50%; */
	}
}`, "",{"version":3,"sources":["webpack://./src/pages/hrzone/general_info/profile.css"],"names":[],"mappings":"AAAA;CACC;AACD;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,gBAAgB;CAChB;AACD;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,aAAa;CACb,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;;;CAGlB,aAAa;CACb,sBAAsB;CACtB;AACD;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR;AACD;;AAEA;CACC,aAAa;CACb,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,uBAAkB;CAAlB,kBAAkB;CAClB,yBAAyB;CACzB,yBAAyB;AAC1B,YAAY;CACX,gBAAgB;AACjB;;;AAGA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,cAAc;AACf;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,yBAAyB;CACzB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC,0BAA0B;CAC3B;;CAEA;EACC;CACD;;CAEA;EACC,gBAAgB;AAClB,uBAAkB;AAAlB,kBAAkB;AAClB;CACC;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD","sourcesContent":[".profile_page {\n\tpadding: 30px\n}\n\n.profile_container {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tcolumn-gap: 30px;\n\trow-gap: 30px\n}\n\n.profile_card {\n\tborder-radius: 20px;\n\tbackground: #fff;\n\tpadding: 30px;\n\tmin-height: 250px;\n\tmin-width: 400px;\n\tposition: relative;\n\n\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between\n}\n\n.full {\n\twidth: 100%;\n\tmargin-top: 30px;\n\tmargin-bottom: 30px;\n}\n\n.profile_card-image {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tmax-Width: 150px\n}\n\n.profile_employee-container {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmargin-top: 20px;\n}\n\n.profile_employee-container p {\n\twidth: fit-content;\n\tcolor: rgb(168, 168, 168);\n\t/* padding: 0 0 12px 0; */\npadding: 1em;\n\tfont-weight: 600;\n}\n\n\n.profile_company-address {\n\tcolor: rgb(168, 168, 168);\n\tfont-weight: 600;\n\tmargin-right: auto;\n\tdisplay: flex;\n\tflex-direction: column;\n\tfont-size: 1em;\n}\n\n.profile_company-address p {\n\tcolor: #000 !important;\n\tfont-size: 1.1em;\n}\n\n.profile_location-text {\n\twidth: 30%;\n\tcolor: rgb(168, 168, 168);\n\tmargin-Top: 20px;\n\tmin-width: 200px;\n}\n\n.profile_location-missingCompanies {\n\tfont-size: 0.9rem !important\n}\n\n@media (max-width: 1400px) {\n\th1 {\n\t\tfont-size: 1.5em\n\t}\n\n\t.profile_card h1:nth-child(2) {\n\t\tfont-size: 48px;\n\t}\n\n\t.profile_location-text {\n\t\twidth: 45%\n\t}\n}\n\n@media (max-width: 900px) {\n\t.profile_container {\n\t\tgrid-template-columns: 1fr;\n\t}\n\n\t.profile_location-text {\n\t\twidth: 60%\n\t}\n\n\t.profile_employee-container p {\n\t\t/* width: 33%; */\nwidth: fit-content;\npadding: .5em\n\t}\n}\n\n@media (max-width: 600px) {\n\t.profile_employee-container p {\n\t\t/* width: 50%; */\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
